import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import SvgIcon from '@material-ui/core/SvgIcon';

import headerIconsStyle from 'assets/jss/material-kit-react/components/headerIconsStyle';

const AboutIcon = ({ classes }) => {
  return (
    <SvgIcon viewBox="0 0 512 512" className={classes.icon}>
      <g>
        <path
          className={classes.fillLighterGrey}
          d="M503.245,264.533c0.102-2.842,0.222-5.675,0.222-8.533C503.467,119.33,392.67,8.533,256,8.533  S8.533,119.33,8.533,256c0,2.859,0.119,5.692,0.222,8.533H503.245z"
          data-original="#87CED9"
          data-old_color="#87CED9"
        />
        <path
          className={classes.fillGrey}
          d="M503.467,256C503.467,119.33,392.67,8.533,256,8.533c-5.734,0-11.409,0.265-17.067,0.649  c45.662,39.296,108.902,116.753,134.059,255.351h130.253C503.347,261.692,503.467,258.859,503.467,256z"
          data-original="#7DC6D1"
          data-old_color="#7DC6D1"
        />
        <path
          className={classes.fillWhite}
          d="M256,196.267L256,196.267c18.85,0,34.133,15.283,34.133,34.133v17.067  c0,18.85-15.283,34.133-34.133,34.133l0,0c-18.85,0-34.133-15.283-34.133-34.133V230.4C221.867,211.55,237.15,196.267,256,196.267z"
          data-original="#FEC9A3"
          data-old_color="#FEC9A3"
        />
        <rect
          x="221.867"
          y="384"
          className={classes.fillDarkerGrey}
          width="68.267"
          height="119.467"
          data-original="#4398D1"
          data-old_color="#4398D1"
        />
        <rect
          x="247.467"
          y="409.6"
          className={classes.fillPurple}
          width="17.067"
          height="93.867"
          data-original="#3685BA"
          data-old_color="#3685BA"
        />
        <path
          className={classes.fillWhite}
          d="M435.2,281.6L435.2,281.6c-18.85,0-34.133-15.283-34.133-34.133V230.4  c0-18.85,15.283-34.133,34.133-34.133l0,0c18.85,0,34.133,15.283,34.133,34.133v17.067C469.333,266.317,454.05,281.6,435.2,281.6z"
          data-original="#FEC9A3"
          data-old_color="#FEC9A3"
        />
        <rect
          x="401.067"
          y="384"
          className={classes.fillDarkerGrey}
          width="68.267"
          height="119.467"
          data-original="#4398D1"
          data-old_color="#4398D1"
        />
        <rect
          x="426.667"
          y="409.6"
          className={classes.fillPurple}
          width="17.067"
          height="93.867"
          data-original="#3685BA"
          data-old_color="#3685BA"
        />
        <path
          className={classes.fillWhite}
          d="M358.4,384l-40.542-85.12c-6.298-10.598-17.664-17.143-29.986-17.28H223.07  c-11.409,0-22.067,5.7-28.399,15.198L153.6,384h34.133l34.133-68.267V384h68.267v-68.267L324.267,384H358.4z"
          data-original="#E0D2C1"
          data-old_color="#E0D2C1"
        />
        <path
          className={classes.fillWhite}
          d="M401.067,281.677c0.751-0.051,1.502-0.077,2.261-0.077h66.005c18.85,0,34.133,15.283,34.133,34.133  V384h-102.4v-68.267L358.4,384h-34.133l49.604-87.202c6.332-9.498,16.99-15.198,28.399-15.198L401.067,281.677z"
          data-original="#F0E4D6"
          data-old_color="#F0E4D6"
        />
        <rect
          x="460.8"
          y="315.733"
          className={classes.fillWhite}
          width="17.067"
          height="68.267"
          data-original="#E0D2C1"
          data-old_color="#E0D2C1"
        />
        <path
          className={classes.fillWhite}
          d="M76.8,196.267L76.8,196.267c18.85,0,34.133,15.283,34.133,34.133v17.067  c0,18.85-15.283,34.133-34.133,34.133l0,0c-18.85,0-34.133-15.283-34.133-34.133V230.4C42.667,211.55,57.95,196.267,76.8,196.267z"
          data-original="#FEC9A3"
          data-old_color="#FEC9A3"
        />
        <g>
          <path
            className={classes.fillWhite}
            d="M76.8,196.267c-2.884,0.034-5.751,0.444-8.533,1.203c15.044,3.857,25.574,17.399,25.6,32.93v17.067   c-0.034,15.531-10.556,29.073-25.6,32.93c17.963,4.932,36.531-5.623,41.463-23.586c0.836-3.046,1.237-6.187,1.203-9.344V230.4   C110.933,211.55,95.65,196.267,76.8,196.267z"
            data-original="#FABD91"
            data-old_color="#FABD91"
          />
          <path
            className={classes.fillWhite}
            d="M256,196.267c-2.884,0.034-5.751,0.444-8.533,1.203c15.044,3.857,25.574,17.399,25.6,32.93v17.067   c-0.034,15.531-10.556,29.073-25.6,32.93c17.963,4.932,36.531-5.623,41.463-23.586c0.836-3.046,1.237-6.187,1.203-9.344V230.4   C290.133,211.55,274.85,196.267,256,196.267z"
            data-original="#FABD91"
            data-old_color="#FABD91"
          />
          <path
            className={classes.fillWhite}
            d="M435.2,196.267c-2.884,0.034-5.751,0.444-8.533,1.203c15.044,3.857,25.574,17.399,25.6,32.93v17.067   c-0.034,15.531-10.556,29.073-25.6,32.93c17.963,4.932,36.531-5.623,41.463-23.586c0.836-3.046,1.237-6.187,1.203-9.344V230.4   C469.333,211.55,454.05,196.267,435.2,196.267z"
            data-original="#FABD91"
            data-old_color="#FABD91"
          />
        </g>
        <rect
          x="42.667"
          y="384"
          className={classes.fillDarkerGrey}
          width="68.267"
          height="119.467"
          data-original="#4398D1"
          data-old_color="#4398D1"
        />
        <rect
          x="68.267"
          y="409.6"
          className={classes.fillPurple}
          width="17.067"
          height="93.867"
          data-original="#3685BA"
          data-old_color="#3685BA"
        />
        <path
          className={classes.fillWhite}
          d="M110.933,281.677c-0.751-0.077-1.502-0.077-2.261-0.077H42.667c-18.85,0-34.133,15.283-34.133,34.133  V384h102.4v-68.267L153.6,384h34.133l-49.604-87.202c-6.332-9.498-16.99-15.198-28.399-15.198L110.933,281.677z"
          data-original="#F0E4D6"
          data-old_color="#F0E4D6"
        />
        <rect
          x="34.133"
          y="315.733"
          className={classes.fillWhite}
          width="17.067"
          height="68.267"
          data-original="#E0D2C1"
          data-old_color="#E0D2C1"
        />
        <g>
          <rect
            x="136.533"
            y="230.4"
            className={classes.fillDarkerGrey}
            width="17.067"
            height="17.067"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
          <rect
            x="170.667"
            y="230.4"
            className={classes.fillDarkerGrey}
            width="17.067"
            height="17.067"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
          <rect
            x="324.267"
            y="230.4"
            className={classes.fillDarkerGrey}
            width="17.067"
            height="17.067"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
          <rect
            x="358.4"
            y="230.4"
            className={classes.fillDarkerGrey}
            width="17.067"
            height="17.067"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
          <path
            className={classes.fillDarkerGrey}
            d="M256,0C114.679,0.162,0.162,114.679,0,256v8.533h17.067V256c-0.034-35.43,7.859-70.417,23.1-102.4   h78.148c-2.739,10.829-5.12,21.751-6.827,32.819l16.862,2.628c1.903-11.938,4.429-23.774,7.578-35.447h111.539v17.067h17.067V153.6   h111.949c3.166,11.674,5.709,23.501,7.62,35.439l16.862-2.611c-1.707-11.093-4.139-21.99-6.827-32.828h77.739   c15.223,31.983,23.1,66.978,23.057,102.4v8.533H512V256C511.838,114.679,397.321,0.162,256,0z M198.246,28.348l4.028-5.12   c14.848-3.43,29.995-5.436,45.227-5.973v42.479h-71.04C183.142,48.879,190.413,38.4,198.246,28.348z M156.51,59.733h-36.548   c17.007-11.844,35.49-21.427,54.972-28.493C168.371,40.474,162.193,49.954,156.51,59.733z M264.533,17.28   c15.386,0.538,30.694,2.577,45.687,6.067l3.934,5.001c7.842,10.052,15.113,20.531,21.794,31.386h-71.415V17.28z M337.587,31.428   c19.294,7.049,37.598,16.563,54.451,28.305H355.9C350.251,50.022,344.149,40.585,337.587,31.428z M49.212,136.533   C62.217,114.108,78.763,93.943,98.21,76.8h48.87c-9.771,19.166-17.826,39.151-24.073,59.733H49.212z M140.954,136.533   c6.647-20.668,15.223-40.661,25.6-59.733h80.913v59.733H140.954z M264.533,136.533V76.8h81.314   c10.385,19.063,18.953,39.066,25.6,59.733H264.533z M389.402,136.533c-6.255-20.582-14.31-40.567-24.073-59.733h48.461   c19.447,17.143,35.994,37.308,48.998,59.733H389.402z"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
          <rect
            x="247.467"
            y="281.6"
            className={classes.fillDarkerGrey}
            width="17.067"
            height="76.8"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
          <rect
            x="426.667"
            y="281.6"
            className={classes.fillDarkerGrey}
            width="17.067"
            height="76.8"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
          <rect
            x="68.267"
            y="281.6"
            className={classes.fillDarkerGrey}
            width="17.067"
            height="76.8"
            data-original="#4398D1"
            data-old_color="#4398D1"
          />
        </g>
        <path
          className={classes.fillPurple}
          d="M256,0c-28.382-0.009-56.567,4.736-83.388,14.02c6.332,6.724,12.979,14.182,19.789,22.272  c1.946-2.645,3.814-5.35,5.845-7.945l4.028-5.12c14.848-3.43,29.995-5.436,45.227-5.973v42.479h-36.412  c4.122,5.461,8.277,11.093,12.45,17.067h23.927v37.026c7.433,12.425,14.805,25.6,21.99,39.774h107.025  c3.166,11.674,5.709,23.501,7.62,35.439l16.862-2.611c-1.707-11.093-4.139-21.99-6.827-32.828h77.739  c15.223,31.983,23.1,66.978,23.057,102.4v8.533H512V256C511.838,114.679,397.321,0.162,256,0z M392.038,59.733H355.9  c-5.649-9.711-11.75-19.149-18.313-28.305C356.881,38.477,375.185,47.991,392.038,59.733z M264.533,17.28  c15.386,0.538,30.694,2.577,45.687,6.067l3.934,5.001c7.842,10.052,15.113,20.531,21.794,31.386h-71.415V17.28z M264.533,136.533  V76.8h81.314c10.385,19.063,18.953,39.066,25.6,59.733H264.533z M389.402,136.533c-6.255-20.582-14.31-40.567-24.073-59.733h48.461  c19.447,17.143,35.994,37.308,48.998,59.733H389.402z"
          data-original="#3E8FC9"
          data-old_color="#3E8FC9"
        />
        <path
          d="M469.333,273.067h-0.222c5.649-7.339,8.721-16.341,8.755-25.6V230.4c0-23.561-19.106-42.667-42.667-42.667  s-42.667,19.106-42.667,42.667v17.067c0.034,9.284,3.123,18.304,8.798,25.66c-14.131,0.324-27.187,7.603-34.884,19.456  l-23.262,40.909l-17.579-38.178c-0.154-0.333-0.324-0.649-0.521-0.956c-7.543-12.442-20.745-20.361-35.277-21.163  c5.709-7.364,8.824-16.41,8.858-25.728V230.4c0-23.561-19.106-42.667-42.667-42.667s-42.667,19.106-42.667,42.667v17.067  c0.034,9.284,3.123,18.304,8.798,25.66c-13.935,0.265-26.846,7.347-34.569,18.944c-0.256,0.384-0.478,0.794-0.674,1.212  l-18.133,40.107l-23.518-41.318c-7.723-11.597-20.634-18.679-34.569-18.944c5.675-7.356,8.764-16.375,8.798-25.66V230.4  c0-23.561-19.106-42.667-42.667-42.667S34.133,206.84,34.133,230.4v17.067c0.034,9.259,3.106,18.261,8.755,25.6h-0.222  C19.115,273.092,0.026,292.181,0,315.733V384c0,4.71,3.823,8.533,8.533,8.533h25.6v110.933c0,4.71,3.823,8.533,8.533,8.533h68.267  c4.71,0,8.533-3.823,8.533-8.533V345.481l26.897,43.042c1.562,2.492,4.292,4.011,7.236,4.011h34.133  c3.046-0.009,5.854-1.63,7.373-4.267c0.051-0.085,0.068-0.188,0.119-0.282c0.051-0.094,0.102-0.119,0.145-0.196l17.963-35.908  v151.586c0,4.71,3.823,8.533,8.533,8.533h68.267c4.71,0,8.533-3.823,8.533-8.533V351.881l17.92,35.934  c0.043,0.085,0.111,0.145,0.154,0.222c0.034,0.085,0.068,0.171,0.111,0.256c0.188,0.299,0.401,0.58,0.631,0.853  c0.188,0.273,0.393,0.546,0.614,0.794c0.316,0.316,0.657,0.597,1.024,0.853c0.589,0.538,1.306,0.939,2.074,1.152  c0.256,0.102,0.486,0.239,0.742,0.316c0.759,0.196,1.545,0.29,2.33,0.273H358.4c2.944,0,5.675-1.519,7.236-4.011l26.897-43.042  v157.986c0,4.71,3.823,8.533,8.533,8.533h68.267c4.71,0,8.533-3.823,8.533-8.533V392.533h25.6c4.71,0,8.533-3.823,8.533-8.533  v-68.267C511.974,292.181,492.885,273.092,469.333,273.067z M409.6,230.4c0-14.14,11.46-25.6,25.6-25.6  c14.14,0,25.6,11.46,25.6,25.6v17.067c0,14.14-11.46,25.6-25.6,25.6c-14.14,0-25.6-11.46-25.6-25.6V230.4z M230.4,230.4  c0-14.14,11.46-25.6,25.6-25.6c14.14,0,25.6,11.46,25.6,25.6v17.067c0,14.14-11.46,25.6-25.6,25.6c-14.14,0-25.6-11.46-25.6-25.6  V230.4z M51.2,247.467V230.4c0-14.14,11.46-25.6,25.6-25.6s25.6,11.46,25.6,25.6v17.067c0,14.14-11.46,25.6-25.6,25.6  S51.2,261.606,51.2,247.467z M102.4,494.933H85.333V409.6H68.267v85.333H51.2v-102.4h51.2V494.933z M158.327,375.467l-40.158-64.256  c-2.5-3.994-7.765-5.214-11.759-2.714c-2.492,1.562-4.011,4.292-4.011,7.236v59.733H51.2v-59.733H34.133v59.733H17.067v-59.733  c0-14.14,11.46-25.6,25.6-25.6h25.6V358.4h17.067v-68.267h23.339c0.486,0,0.981,0,1.468,0.043h0.256c0.367,0,0.725,0,1.075,0  c7.731,0.469,14.822,4.454,19.243,10.82l42.351,74.47H158.327z M281.6,494.933h-17.067V409.6h-17.067v85.333H230.4v-102.4h51.2  V494.933z M297.813,311.919c-2.057-4.241-7.159-6.016-11.401-3.959c-2.978,1.442-4.847,4.471-4.813,7.774v59.733h-51.2v-59.733  c0.009-4.71-3.814-8.533-8.525-8.542c-3.243,0-6.204,1.826-7.646,4.727l-26.496,53.001l-7.62-15.232l22.016-48.64  c4.779-6.835,12.595-10.914,20.941-10.914h24.397V358.4h17.067v-68.267h23.339c9.207,0.111,17.707,4.966,22.477,12.843  l21.521,46.737l-7.603,15.206L297.813,311.919z M460.8,494.933h-17.067V409.6h-17.067v85.333H409.6v-102.4h51.2V494.933z   M494.933,375.467h-17.067v-59.733H460.8v59.733h-51.2v-59.733c0-4.71-3.823-8.533-8.533-8.533c-2.944,0-5.675,1.519-7.236,4.011  l-40.158,64.256h-14.737l42.035-73.933c4.395-6.622,11.631-10.812,19.558-11.341c0.35,0,0.708,0,1.067,0h0.264  c0.486,0,0.981-0.043,1.468-0.043h23.339v68.267h17.067v-68.284h25.6c14.14,0,25.6,11.46,25.6,25.6V375.467z"
          data-original="#000000"
          className={classes.fillPurple}
          data-old_color="#000000"
        />
        <path
          d="M256,0C114.679,0.162,0.162,114.679,0,256v8.533h17.067V256c-0.034-35.43,7.859-70.417,23.1-102.4h78.148  c-2.739,10.829-5.12,21.751-6.827,32.819l16.862,2.628c1.903-11.938,4.429-23.774,7.578-35.447h111.539v17.067h17.067V153.6h111.949  c3.166,11.674,5.709,23.501,7.62,35.439l16.862-2.611c-1.707-11.093-4.139-21.99-6.827-32.828h77.739  c15.223,31.983,23.1,66.978,23.057,102.4v8.533H512V256C511.838,114.679,397.321,0.162,256,0z M198.246,28.348l4.028-5.12  c14.848-3.43,29.995-5.427,45.227-5.973v42.479h-71.04C183.142,48.879,190.413,38.4,198.246,28.348z M156.51,59.733h-36.548  c17.007-11.844,35.49-21.427,54.972-28.493C168.371,40.474,162.193,49.954,156.51,59.733z M264.533,17.28  c15.386,0.538,30.694,2.577,45.687,6.067l3.934,5.001c7.842,10.052,15.113,20.531,21.794,31.386h-71.415V17.28z M337.587,31.428  c19.294,7.049,37.598,16.563,54.451,28.305H355.9C350.251,50.022,344.149,40.585,337.587,31.428z M49.212,136.533  C62.217,114.108,78.763,93.943,98.21,76.8h48.87c-9.771,19.166-17.826,39.151-24.073,59.733H49.212z M140.954,136.533  c6.647-20.668,15.223-40.661,25.6-59.733h80.913v59.733H140.954z M264.533,136.533V76.8h81.314  c10.385,19.063,18.953,39.066,25.6,59.733H264.533z M389.402,136.533c-6.255-20.582-14.31-40.567-24.073-59.733h48.461  c19.447,17.143,35.994,37.308,48.998,59.733H389.402z"
          data-original="#000000"
          className={classes.fillPurple}
          data-old_color="#000000"
        />
        <rect
          x="136.533"
          y="230.4"
          width="17.067"
          height="17.067"
          data-original="#000000"
          className={classes.fillPurple}
          data-old_color="#000000"
        />
        <rect
          x="170.667"
          y="230.4"
          width="17.067"
          height="17.067"
          data-original="#000000"
          className={classes.fillPurple}
          data-old_color="#000000"
        />
        <rect
          x="324.267"
          y="230.4"
          width="17.067"
          height="17.067"
          data-original="#000000"
          className={classes.fillPurple}
          data-old_color="#000000"
        />
        <rect
          x="358.4"
          y="230.4"
          width="17.067"
          height="17.067"
          data-original="#000000"
          className={classes.fillPurple}
          data-old_color="#000000"
        />
      </g>
    </SvgIcon>
  );
};

export default withStyles(headerIconsStyle)(AboutIcon);
